// auth.js

export const isAuthenticated = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const token = localStorage.getItem('authToken'); // Ensure correct key is used for the token

  // Get the current path (window.location.pathname)
  const currentPath = window.location.pathname;

  // Avoid logging out if the user is on the login page
  if (currentPath === '/' && (!isLoggedIn || !token)) {
    return false;
  }

  // If either 'isLoggedIn' or the token is missing, log the user out
  if (!isLoggedIn || !token) {
    logout();
    return false;
  }

  // Skip decoding logic since the token is not a JWT
  return true; // User is authenticated if 'isLoggedIn' and token exist
};




// Function to handle user login. It sets 'isLoggedIn' to 'true' in localStorage
export const login = () => {
  localStorage.setItem('isLoggedIn', 'true');
};

// Function to handle user logout. It removes 'isLoggedIn' from localStorage
export const logout = () => {
  // Clear all storage
  localStorage.clear();
  sessionStorage.clear();

  // Avoid unnecessary redirects
  if (window.location.pathname !== '/') {
    window.location.href = '/'; // Redirect only if not already on the login page
  }
};